import { toApiStatus, toUiStatus } from './_helpers';

/** API Villager ↔ UI people master fields. */

export function villagerFromApi(row) {
  if (!row) return null;
  return {
    id: row.id,
    peopleId: row.code ?? '',
    name: row.name ?? '',
    fatherHusbandName: row.fatherHusbandName ?? '',
    surname: row.surname ?? '',
    fullName: row.fullName ?? '',
    mobile: row.mobile ?? '',
    email: row.email ?? '',
    aadhaar: row.aadhaar ?? '',
    pan: row.pan ?? '',
    electionCard: row.electionCard ?? '',
    drivingLicense: row.drivingLicense ?? '',
    dob: row.dob ?? '',
    gender: row.gender ?? '',
    address1: row.address1 ?? '',
    address2: row.address2 ?? '',
    villageId: row.village?.code ?? row.villageId ?? '',
    villageDbId: row.villageId ?? null,
    villageName: row.village?.name ?? '',
    villagePin: row.village?.pin ?? '',
    pin: row.pin ?? '',
    education: row.education ?? '',
    educationDetails: row.educationDetails ?? '',
    photo: null,
    photoDocumentId: row.photoDocumentId ?? null,
    verificationStatus: toUiStatus(row.verificationStatus),
    rejectionReason: row.rejectionReason ?? '',
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
    equipments: Array.isArray(row.equipments)
      ? row.equipments.map((e) => ({
          name: e?.name || e?.equipmentType || 'Equipment',
          regNo: e?.regNo || '',
          equipmentType: e?.equipmentType || '',
        }))
      : [],
  };
}

export function villagerToApi(ui) {
  if (!ui) return null;
  return {
    name: ui.name,
    fatherHusbandName: ui.fatherHusbandName || null,
    surname: ui.surname || null,
    fullName: ui.fullName || null,
    mobile: ui.mobile,
    email: ui.email || null,
    aadhaar: ui.aadhaar || null,
    pan: ui.pan || null,
    electionCard: ui.electionCard || null,
    drivingLicense: ui.drivingLicense || null,
    dob: ui.dob || null,
    gender: ui.gender || null,
    address1: ui.address1 || null,
    address2: ui.address2 || null,
    villageId: ui.villageDbId ?? ui.villageId,
    pin: ui.pin || null,
    education: ui.education || null,
    educationDetails: ui.educationDetails || null,
    photoDocumentId: ui.photoDocumentId ?? null,
    verificationStatus: ui.verificationStatus
      ? toApiStatus(ui.verificationStatus)
      : undefined,
    rejectionReason: ui.rejectionReason || null,
    isActive: ui.active !== false,
  };
}

/** Confirmed villager profile photo from the documents list. */
export function profilePhotoFromDocuments(docs, photoDocumentId) {
  if (!Array.isArray(docs) || !docs.length) return null;
  const byId = photoDocumentId
    ? docs.find((d) => d.id === photoDocumentId)
    : null;
  const photos = docs.filter(
    (d) => d.docType === 'profile_photo' || d.docType === 'photo',
  );
  const raw = byId || photos[photos.length - 1] || null;
  if (!raw?.url) return null;
  return {
    id: raw.id,
    label: 'Profile photo',
    fileName: raw.fileName || 'photo',
    mimeType: raw.mimeType || '',
    kind: String(raw.mimeType || '').includes('pdf') ? 'pdf' : 'image',
    url: raw.url,
    name: raw.fileName || 'photo',
  };
}
